import { Box } from '@factorialco/deprecated-design-system'
import { PlanningBalancesByPeriodsQuery, PlanningBalancesQuery } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'

import useFetchPlannedBreaks from 'modules/shift_management/hooks/useFetchPlannedBreaks'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow, View } from 'modules/shift_management/lib/types'
import { PlannedBreaksProvider } from 'modules/time_planning/store/internal/collections/plannedBreaks'

import DataTable from './DataTable'

type TimePlanningBalance = NonNullable<
  PlanningBalancesQuery['timePlanning']['balancesConnection']['nodes']
>[number]
type TimePlanningBalancesByPeriod = NonNullable<
  PlanningBalancesByPeriodsQuery['timePlanning']['balancesByPeriodsConnection']['nodes']
>[number]

interface BodyProps {
  isLoading: boolean
  shiftsRows: ShiftsRow[]
  view: View
  showCoverageSection: boolean
  balancesByEmployee: Record<string, TimePlanningBalance>
  periodBalancesByEmployee: Record<string, TimePlanningBalancesByPeriod[]>
}

const Body = ({
  isLoading,
  shiftsRows,
  view,
  showCoverageSection,
  balancesByEmployee,
  periodBalancesByEmployee,
}: BodyProps) => {
  const [{ shiftsToQuery }] = useSchedule()
  // TODO: Remove this hook once 'dev_shift_management_graphql_migration' is done
  const { plannedBreaks } = useFetchPlannedBreaks(shiftsToQuery, view)

  if (isLoading) {
    return (
      <Box flexGrow background="grey000White">
        <Loading />
      </Box>
    )
  }

  return (
    <PlannedBreaksProvider collection={plannedBreaks}>
      <DataTable
        shiftsRows={shiftsRows}
        balancesByEmployee={balancesByEmployee}
        periodBalancesByEmployee={periodBalancesByEmployee}
        view={view}
        showCoverageSection={showCoverageSection}
      />
    </PlannedBreaksProvider>
  )
}

export default observer(Body)
